// extracted by mini-css-extract-plugin
module.exports = {"logo":"BasicLayout_logo__1aC-G","header":"BasicLayout_header__2ML-x","left":"BasicLayout_left__3RV-B","right":"BasicLayout_right__C8PXk"};